(() => {
  const CART_DRAWER_ID = 'cart-drawer';
  const STYLE_ID = 'studio-global-refinements';

  const getDrawer = () => document.getElementById(CART_DRAWER_ID);
  const getBackdrop = () => document.querySelector('[data-studio-cart-backdrop]');

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .studio-collection-card__media,
      .studio-menu-product__media,
      .studio-search-card__media,
      .studio-product-card__media,
      .studio-product-v2-card__media,
      .studio-search-result__media {
        overflow: hidden !important;
      }

      .studio-collection-card__image,
      .studio-menu-product__media img,
      .studio-search-card__media img,
      .studio-product-card__media img,
      .studio-product-v2-card__image,
      .studio-search-result__image {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
      }

      .studio-cart-backdrop {
        position: fixed;
        z-index: 10000;
        inset: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        background: rgb(0 0 0 / 0.25);
        border: 0;
        cursor: default;
      }

      .studio-cart-backdrop[hidden] { display: none !important; }
      body.studio-cart-open { overflow: hidden !important; }
      body.studio-cart-open .page-wrapper,
      body.studio-cart-open .page-wrapper--drawer-open {
        width: 100% !important;
        margin-inline: 0 !important;
        transform: none !important;
      }

      #cart-drawer .theme-drawer__dialog {
        --theme-drawer-width: min(520px, calc(100vw - 20px));
        --theme-drawer-padding: 18px;
        z-index: 10001 !important;
        width: var(--theme-drawer-width) !important;
        max-width: calc(100vw - 20px) !important;
        color: #090909 !important;
        font-family: var(--studio-ui-font, 'Helvetica Neue', Helvetica, Arial, sans-serif) !important;
        background: #fff !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      #cart-drawer .theme-drawer__dialog::backdrop {
        background: rgb(0 0 0 / 0.25);
      }

      #cart-drawer .theme-drawer__header {
        min-height: 68px;
        padding: 0 20px;
        border-bottom: 0;
      }

      #cart-drawer .theme-drawer__title {
        margin: 0;
        font: 400 15px/1.1 var(--studio-ui-font, sans-serif) !important;
        letter-spacing: 0;
        text-transform: none;
      }

      #cart-drawer .theme-drawer__badge { display: none !important; }
      #cart-drawer .theme-drawer__close-button,
      #cart-drawer .cart-drawer__close-button--empty {
        width: 38px !important;
        height: 38px !important;
        padding: 6px !important;
        color: #090909 !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      #cart-drawer .theme-drawer__close-button .svg-wrapper,
      #cart-drawer .theme-drawer__close-button svg {
        width: 27px !important;
        height: 27px !important;
      }

      #cart-drawer .cart-drawer__inner,
      #cart-drawer .cart-drawer__content,
      #cart-drawer .cart-drawer__items {
        color: #090909;
        background: #fff !important;
      }

      #cart-drawer .cart-drawer__content { height: calc(100% - 68px) !important; }
      #cart-drawer .cart-drawer__items { padding: 8px 20px 24px !important; }
      #cart-drawer .cart-items,
      #cart-drawer .cart-items__table,
      #cart-drawer .cart-items__table tbody { width: 100%; }

      #cart-drawer .cart-items__table-row {
        display: grid !important;
        width: 100% !important;
        grid-template-columns: 96px minmax(0, 1fr) auto !important;
        grid-template-rows: min-content min-content min-content auto !important;
        grid-template-areas:
          'media details price'
          'media variants price'
          'media quantity quantity'
          'error error error' !important;
        column-gap: 16px !important;
        row-gap: 2px !important;
        padding: 10px 0 24px !important;
        margin: 0 0 14px !important;
        border-bottom: 0 !important;
      }

      #cart-drawer .cart-items__details { display: contents !important; }
      #cart-drawer .cart-items__media { grid-area: media !important; }
      #cart-drawer .cart-items__product-info { grid-area: details !important; min-width: 0; }
      #cart-drawer .cart-items__variants-wrapper { grid-area: variants !important; }
      #cart-drawer .cart-items__quantity { grid-area: quantity !important; margin-top: 9px !important; }
      #cart-drawer .cart-items__price { grid-area: price !important; min-width: 92px !important; text-align: right !important; }
      #cart-drawer .cart-items__error { grid-area: error !important; }
      #cart-drawer .cart-items__unit-price-wrapper { display: none !important; }

      #cart-drawer .cart-items__media-container {
        width: 96px !important;
        height: 82px !important;
        aspect-ratio: auto !important;
        align-items: center;
        justify-content: center;
        background: #f5f5f3;
      }

      #cart-drawer .cart-items__media-image {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        border: 0 !important;
        border-radius: 0 !important;
      }

      #cart-drawer .cart-items__title,
      #cart-drawer .cart-items__details *,
      #cart-drawer .cart-items__price,
      #cart-drawer .cart-items__variants-wrapper {
        color: #090909 !important;
        font-family: var(--studio-ui-font, sans-serif) !important;
      }

      #cart-drawer .cart-items__title {
        overflow: hidden;
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.2 !important;
        text-overflow: ellipsis;
        text-transform: none !important;
        white-space: nowrap;
      }

      #cart-drawer .cart-items__price,
      #cart-drawer .cart-items__price * {
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.2 !important;
      }

      #cart-drawer .cart-items__variants,
      #cart-drawer .cart-items__variant,
      #cart-drawer .studio-cart-size {
        margin: 3px 0 0 !important;
        font-size: 12px !important;
        line-height: 1.2 !important;
      }

      #cart-drawer .quantity-selector {
        min-height: 28px !important;
        height: 28px !important;
        color: #090909 !important;
        background: #fff !important;
        border: 1px solid #090909 !important;
        border-radius: 0 !important;
      }

      #cart-drawer .quantity-selector button,
      #cart-drawer .quantity-selector input {
        min-width: 29px !important;
        height: 26px !important;
        padding: 0 !important;
        font: 12px/1 var(--studio-ui-font, sans-serif) !important;
      }

      #cart-drawer .cart-items__remove {
        width: 28px !important;
        height: 28px !important;
        min-height: 28px !important;
      }

      #cart-drawer .cart-drawer__summary {
        position: sticky !important;
        bottom: 0 !important;
        display: block !important;
        width: 100%;
        gap: 0 !important;
        margin-top: auto !important;
        padding: 18px 20px 20px !important;
        background: #fff !important;
        border-top: 1px solid #dedede;
        mask-image: none !important;
      }

      #cart-drawer .cart-totals,
      #cart-drawer .cart-totals__container { gap: 0 !important; }
      #cart-drawer .cart-totals:not(:has(.cart-actions)) {
        margin: 0 0 18px !important;
        padding: 0 !important;
        border: 0 !important;
      }

      #cart-drawer .cart-totals__total { min-height: 28px; }
      #cart-drawer .cart-totals__total-label {
        color: #777 !important;
        font: 10px/1 var(--studio-ui-font, sans-serif) !important;
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
      #cart-drawer .cart-totals__total-value {
        color: #090909 !important;
        font: 650 16px/1 var(--studio-ui-font, sans-serif) !important;
      }

      #cart-drawer .cart-totals__tax-note,
      #cart-drawer .cart-actions,
      #cart-drawer .additional-checkout-buttons { display: none !important; }
      #cart-drawer .cart__ctas { margin-top: 16px; }

      #cart-drawer #checkout {
        min-height: 46px !important;
        width: 100% !important;
        padding: 0 14px !important;
        color: #fff !important;
        font: 600 12px/1 var(--studio-ui-font, sans-serif) !important;
        letter-spacing: 0.01em;
        text-transform: uppercase;
        background: #090909 !important;
        border: 1px solid #090909 !important;
        border-radius: 0 !important;
      }

      #cart-drawer .cart-drawer--empty .cart-drawer__content {
        align-items: flex-start !important;
        justify-content: flex-start !important;
        padding: 24px 20px !important;
        text-align: left !important;
      }

      #cart-drawer .cart-items__empty-button {
        min-height: 42px;
        margin: 24px 0 0 !important;
        color: #fff;
        background: #090909;
        border-radius: 0;
      }

      @media screen and (max-width: 749px) {
        #cart-drawer .theme-drawer__dialog {
          --theme-drawer-width: calc(100vw - 18px);
          max-width: calc(100vw - 18px) !important;
        }
        #cart-drawer .theme-drawer__header { min-height: 58px; padding: 0 14px; }
        #cart-drawer .cart-drawer__content { height: calc(100% - 58px) !important; }
        #cart-drawer .cart-drawer__items { padding: 8px 14px 20px !important; }
        #cart-drawer .cart-drawer__summary { padding: 16px 14px 18px !important; }
        #cart-drawer .cart-items__table-row {
          grid-template-columns: 82px minmax(0, 1fr) auto !important;
          column-gap: 12px !important;
        }
        #cart-drawer .cart-items__media-container { width: 82px !important; height: 74px !important; }
        #cart-drawer .cart-items__price { min-width: 80px !important; }
      }
    `;
    document.head.append(style);
  }

  function ensureBackdrop() {
    const existing = getBackdrop();
    if (existing) return existing;

    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'studio-cart-backdrop';
    backdrop.dataset.studioCartBackdrop = '';
    backdrop.setAttribute('aria-label', 'Close cart');
    backdrop.hidden = true;
    document.body.append(backdrop);
    return backdrop;
  }

  function getCartCount() {
    const badge = getDrawer()?.querySelector('.theme-drawer__badge');
    const badgeCount = Number.parseInt(badge?.textContent?.trim() || '', 10);
    if (Number.isFinite(badgeCount)) return badgeCount;

    let inputCount = 0;
    getDrawer()?.querySelectorAll('input[name="updates[]"]').forEach((input) => {
      inputCount += Number.parseInt(input.value || '0', 10) || 0;
    });
    if (inputCount > 0) return inputCount;

    const bagText = document.querySelector('.studio-header__utilities a[href*="/cart"], [data-studio-cart-trigger]')?.textContent || '';
    const match = bagText.match(/\((\d+)\)/);
    return match ? Number(match[1]) : 0;
  }

  function updateBagCount(count) {
    document.querySelectorAll('.studio-header__utilities a[href*="/cart"], .studio-header__utilities [data-studio-cart-trigger]').forEach((trigger) => {
      const label = `Bag (${count})`;
      setText(trigger, label);
      trigger.setAttribute('aria-label', `Open bag with ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  }

  function updateCartChrome() {
    const drawer = getDrawer();
    if (!drawer) return;

    const count = getCartCount();
    setText(drawer.querySelector('#cart-drawer-heading'), `Your cart - ${count} ${count === 1 ? 'item' : 'items'}`);

    drawer.querySelectorAll('.cart-items__table-row').forEach((row) => {
      const variants = row.querySelector('.cart-items__variants-wrapper');
      if (variants && !variants.textContent.trim()) {
        const size = document.createElement('span');
        size.className = 'studio-cart-size';
        size.textContent = 'Size: Adjustable';
        variants.append(size);
      }
    });

    setText(drawer.querySelector('.cart-totals__total-label'), 'Subtotal');

    const total = drawer.querySelector('[data-cart-subtotal]')?.textContent?.trim();
    setText(drawer.querySelector('#checkout .button-text'), total ? `Check out  •  ${total}` : 'Check out');
    updateBagCount(count);
  }

  let updateScheduled = false;
  function scheduleUpdate() {
    if (updateScheduled) return;
    updateScheduled = true;
    requestAnimationFrame(() => {
      updateScheduled = false;
      updateCartChrome();
      bindBagTriggers();
    });
  }

  async function openCartDrawer(trigger) {
    const drawer = getDrawer();
    if (!drawer) {
      window.location.assign('/cart');
      return;
    }

    await customElements.whenDefined('theme-drawer');
    drawer.open?.();
    trigger?.setAttribute('aria-expanded', 'true');
    scheduleUpdate();
  }

  function bindBagTriggers() {
    document.querySelectorAll('.studio-header__utilities a[href*="/cart"], .studio-header__utilities [data-studio-cart-trigger]').forEach((trigger) => {
      if (trigger.dataset.studioCartBound === 'true') return;

      trigger.dataset.studioCartBound = 'true';
      trigger.dataset.studioCartTrigger = '';
      trigger.setAttribute('aria-controls', CART_DRAWER_ID);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openCartDrawer(trigger);
      });
    });
  }

  function setupCartDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.setAttribute('no-persist', '');
    drawer.querySelector('cart-drawer-component')?.setAttribute('auto-open', '');

    const target = document.getElementById('shopify-section-cart-drawer-section') || drawer;
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(target, { childList: true, subtree: true });
  }

  function setupBackdrop() {
    const backdrop = ensureBackdrop();
    backdrop.addEventListener('click', () => getDrawer()?.close?.());

    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target?.id !== CART_DRAWER_ID) return;
      backdrop.hidden = false;
      document.body.classList.add('studio-cart-open');
      scheduleUpdate();
    });

    document.addEventListener('theme-drawer:close', (event) => {
      if (event.target?.id !== CART_DRAWER_ID) return;
      backdrop.hidden = true;
      document.body.classList.remove('studio-cart-open');
      document.querySelectorAll('[data-studio-cart-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    injectStyles();
    ensureBackdrop();
    bindBagTriggers();
    setupCartDrawer();
    setupBackdrop();
    scheduleUpdate();

    const header = document.getElementById('header-group');
    if (header) new MutationObserver(bindBagTriggers).observe(header, { childList: true, subtree: true });

    document.addEventListener('cart:lines-update', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
